import React from 'react'
import PropTypes from 'prop-types'
import { Section, TitleBar } from '../../views/includes/Wrappers'
import AppRoutes from '../../../routes/appRoutes'

const FormHeader = ({ backLink, headerTitle }) => (
    <header className="header--main">
        <Section>
            <TitleBar
                backLink={backLink ? backLink : AppRoutes.dashboard()}
                title={headerTitle}
            />
        </Section>
    </header>
)

FormHeader.propTypes = {
    backLink: PropTypes.string,
    headerTitle: PropTypes.string.isRequired,
}

export default FormHeader
